var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.9375C10.5178 10.9375 10.9375 10.5178 10.9375 10C10.9375 9.48223 10.5178 9.0625 10 9.0625C9.48223 9.0625 9.0625 9.48223 9.0625 10C9.0625 10.5178 9.48223 10.9375 10 10.9375Z",
    fill: "#3D4837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 10.9375C15.8303 10.9375 16.25 10.5178 16.25 10C16.25 9.48223 15.8303 9.0625 15.3125 9.0625C14.7947 9.0625 14.375 9.48223 14.375 10C14.375 10.5178 14.7947 10.9375 15.3125 10.9375Z",
    fill: "#3D4837"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 10.9375C5.20527 10.9375 5.625 10.5178 5.625 10C5.625 9.48223 5.20527 9.0625 4.6875 9.0625C4.16973 9.0625 3.75 9.48223 3.75 10C3.75 10.5178 4.16973 10.9375 4.6875 10.9375Z",
    fill: "#3D4837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsAction);
export default __webpack_public_path__ + "static/media/threeDotsAction.875bfe8f20ba9ea062f526804da995c5.svg";
export { ForwardRef as ReactComponent };